const ContentType = {
    TachoMain: 1,

    NotificationList: 44,

    OperationSetting: 2,
        AuthorityManagement: 3,
            MenuPermission: 4,
            PartnerPermission: 5,
        OrganizationManagement: 6,
        AccountManagement: 7,

    CombinedTaxiActivity: 61,
    CorporateTaxi: 8,
        ClosingDay: 9,
        ClosingDayCommute: 37,
        ClosingMonth: 10,
        ClosingMonthCommute: 38,
        DrivingAggregateDetails: 11,
        DrivingGraphAnalysis: 12,
        DrivingRoute: 13,
        TachoData: 34,
        TachoDataCommute: 39,
        TachoDataPostech: 42,
        TachoDataAndRoute: 52,
        CommuteManagement: 40,
        DrivingDist: 46,
        TachoVoucher : 56,
        TripTransactions : 64,

    PrivateTaxi: 14,
        PrivateClosingDay: 15,
        PrivateDrivingAggregateDetails: 16,
        PrivateDrivingGraphAnalysis: 45,
        PrivateDrivingRoute: 17,
        PrivateDrivingData: 36,
        PrivateButtonEvent: 41,
        PrivateTachoVoucher : 57,

    MasterData: 18,
        DrivingPerMinute: 19,
        ButtonEvent: 20,

    Management: 21,
        AddDevice: 22,
        Company: 23,
        MyCompanies: 65,
        Vehicle: 24,
        Employee: 35,
        EmployeeWithCard: 62,
        InvalidData: 63,
        LastTransaction: 48,
        LocationHistory: 66,
    DataExtraction : 49,
        DataReq : 50 ,
        DataEzl : 51 ,
    Monitoring: 26,
    Statics : 53,
        StaticsCorp : 54,
        StaticsReg : 55,
    AcrmData : 58,
        TachoAcrmData : 59
}

export default ContentType
